<template>
<!-- WHAT: A components to collect column-distinct model data (Copied from BtDimsDimModel and removed extra fields).
   HISTORY:
   * V260127.1: Added app_code and event_code to varcharColumns when missing (in some schemas they may be BIGINT).
   * V251120.1: Added an isPaginatedTable prop and consumed the initial-column prop of BtColumnDistinctModel.
      Also hid the model dropdown when only one item was available, and fixed an issue where the Save button was not enabling/disabling correctly.
   * V251027.1: 1st release.
-->
<v-form lazy-validation
   ref="form"
   v-model="isFormValid"
>
   <v-row class="px-2 pb-2" v-if="!initialColumn">
      <v-col cols="12" class="py-0">
         <v-autocomplete persistent-hint required
            ref="column"
            autocomplete="off"
            class="py-0"
            placeholder="select a column..."
            hint="* Column Name"
            :items="varcharColumns"
            :rules="[rules.required]"
            v-model="column"
            @change="columnChanged"
         ></v-autocomplete>
      </v-col>
   </v-row>
   <v-row>
      <v-col cols="12" class="pb-0">
         <bt-metrics-model no-label
            :initial-model="initialModel"
            :max="0"
            :schemas="schemas"
            :query-submitted="querySubmitted"
            v-model="metricsData"
            @form-valid="metricsDataChanged"
         />
      </v-col>
   </v-row>
</v-form>
</template>

<script>
import BtMetricsModel from './BtMetricsModel.vue';
import { isEmpty } from '../mixins/bt-mixin.js';

const NAME = "BtColumnDistinctModel";
const VERSION = 'V260127.1';
const EXCLUDED_COLUMNS = ['_id', 'dedupHash'];

export default {
   name: NAME,

   components: {
      BtMetricsModel
   },

   props: {
      value: {
         type: Object,
         default: () => ({})
      },
      debug: {
         type: Boolean,
         default: false
      },
      initialColumn: {
         type: String
      },
      initialModel: {
         type: Boolean
      },
      querySubmitted: {
         type: Boolean,
         required: true
      },
      schemas: {
         type: Array,
         required: true,
         default: () => []
      }
   },

   data() {
      return {
         rules: {
            required: value => !!value || 'Value is required!',
         },
         isFormValid: false,
         isMetricsModelValid: true,
         varcharColumns: [],
         column: '',
         metricsData: {}
      }
   },

   computed: {},

   watch: {
      initialModel: {
         immediate: true,
         handler(val) {
            if (val) this.init();
         }
      },

      schemas: {
         immediate: true,
         deep: true,
         async handler(val) {
            // this.alert('in ' + NAME + '/watch: schemas=' + JSON.stringify(val));
            // this.formChanged();
            if (val?.length) {
               this.varcharColumns = val.filter(col => (col.column_type === 'VARCHAR' && !EXCLUDED_COLUMNS.includes(col.column_name))
                  || ['app_code', 'event_code'].includes(col.column_name)) //V260127
                  .map(col => col.column_name);

               if (this.initialColumn) {
                  if (!this.varcharColumns.includes(this.initialColumn))
                     this.varcharColumns.push(this.initialColumn);
               }
            } else {
               this.varcharColumns = [];
            }

            this.init();
            this.$nextTick(() => {
               // this.formChanged();
               this.$refs.column?.focus();
            });

            this.isFormChanged = false;
         }
      }
   },

   methods: {
      alert(msg) {
         if (this.debug) {
            alert(`${NAME} ${VERSION} says:\n${msg}`);
         }
      },

      log(msg, always =false) {
         if (this.debug || always) {
            console.log(`-----${NAME} ${VERSION} says => ${msg}`);
         }
      },

      init() {
         this.column = '';
         this.metricsData = {};
         // if (this.varcharColumns.length && !isEmpty(this.value)) {
         //    const { column } = this.value;
         //    this.column = this.varcharColumns.includes(column) ? column : '';
         //    this.metricsData = {
         //       ...(this.value.whereClause && { whereClause: this.value.whereClause })
         //    }
         // } else {
         //    this.column = '';
         //    this.metricsData = {};
         // }
         if (this.varcharColumns.length) {
            if (isEmpty(this.value)) {
               if (this.initialColumn) {
                  this.column = this.initialColumn;
                  this.columnChanged();
               }
            } else {
               const { column } = this.value;
               if (this.varcharColumns.includes(column))
                  this.column = column;
               this.metricsData = {
                  ...(this.value.whereClause && { whereClause: this.value.whereClause })
               }
            }
         }

         this.$nextTick(() => {
            this.$refs.form?.validate();
            // // if (!this.isFormValid) this.formChanged//TODO: what is this for?
         });
      },
     
      columnChanged() {
         this.formChanged();
      },

      metricsDataChanged(val) {
         // alert('in metricsDataChanged(): val=' + val);
         this.isMetricsModelValid = val;
         this.formChanged();
      },

      formChanged() {
         let emitVal = false;
         this.isFormValid = this.$refs.form?.validate();
         // alert('isFormValid='+this.isFormValid)
         if (this.isFormValid && this.isMetricsModelValid) {
            const modelData = {
               column: this.column,
               ...this.metricsData
            };

            this.$emit('input', modelData);
            emitVal = true;
         }

         this.$emit('form-valid', emitVal);
      }
   },

   mounted() {
      // alert(`in ${NAME}.mounted(): `);
      if (this.initialModel === undefined)
         this.init();
   }
}
</script>

<style scoped>
</style>